import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Slot } from "@radix-ui/react-slot";
import { tv } from "tailwind-variants";
import cn from "../../utils/cn";
const linkVariants = tv({
    base: "cursor-pointer font-bold text-link underline transition-colors hover:text-primary-dark focus:text-primary-dark focus-visible:text-primary-dark",
    variants: {
        size: {
            sm: "text-sm",
            md: "text-md",
        },
    },
    defaultVariants: {
        size: "md",
    },
});
const Link = React.forwardRef(({ className, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "a";
    return _jsx(Comp, { className: cn(linkVariants({ size, className })), ref: ref, ...props });
});
Link.displayName = "Link";
export default Link;
